import { createSelector } from 'reselect'

import { allCardsSelector } from './cardsFirstOrder'
import { allCharactersSelector } from './charactersFirstOrder'
import { allNotesSelector } from './notesFirstOrder'
import { allPlacesSelector } from './placesFirstOrder'

/**
 * @typedef {import('../index').PlottrState} PlottrState
 * @typedef {import('../index').Card} Card
 * @typedef {import('../index').Character} Character
 * @typedef {import('../index').Note} Note
 * @typedef {import('../index').Place} Place
 */

const filterTypeSelector = (_state, type) => type
/**
 * @type {function(PlottrState, String): (Array<Card> | Array<Character> | Array<Note> | Array<Place>)}
 */
export const filterItemsSelector = createSelector(
  allCardsSelector,
  allCharactersSelector,
  allNotesSelector,
  allPlacesSelector,
  filterTypeSelector,
  (cards, characters, notes, places, type) => {
    switch (type) {
      case 'outline':
      case 'cards': {
        return cards
      }
      case 'characters': {
        return characters
      }
      case 'notes': {
        return notes
      }
      case 'places': {
        return places
      }
      default: {
        return []
      }
    }
  }
)
